/**
 * Deterministic color for a given notice id, stable regardless of what
 * other events exist or their order — unlike assigning colors by
 * chronological position among currently-visible events, which shifts
 * every event's color whenever another event is added or removed.
 */
export function getNoticeEventColor(
  noticeId: string,
  colors: readonly string[]
): string {
  if (colors.length === 0) return "";

  let hash = 0;
  for (let i = 0; i < noticeId.length; i++) {
    hash = noticeId.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
}
